export default __webpack_public_path__ + "static/media/edit.7225f1bb.svg";